<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" ref="mapForm">
        <el-form-item label="合作方式" required>
          <el-radio-group v-model="form.type" :disabled="form.id > 0">
            <el-radio
              :label="item.value"
              v-for="(item, i) in coopType"
              :key="i"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="合作门店" required v-if="form.id">
          {{temp.mechanism.mechanism_name}}
        </el-form-item>
         <el-form-item label="合作门店" required v-else>
          <mechanism-select :condition="{is_union:true}" :mecid.sync="form.mechanism_id"></mechanism-select>
        </el-form-item>
        <el-form-item label="合作时间" required>
          <el-date-picker
            v-model="form.start_time"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="form.end_time"
            value-format="yyyy-MM-dd 23:59:59"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合作类目" required v-if="form.type == 3">
          <el-select
            v-model="change_categories"
            multiple
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in categories"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业额分成比例" required v-permission="'setCoachPromoterRatio'">
          <el-input v-model="form.ratio"></el-input>
          <div>
            额外分成比例，不包括课时费
          </div>
        </el-form-item>
        <el-form-item label="支付金额" v-if="!form.id" v-permission="'setPromoterPrice'">
          <el-input v-model="form.pay_amount"></el-input>
          <p>
            不填为合作默认金额，填写后对方仅需支付填写的金额
          </p>
        </el-form-item>
       <el-form-item label="结算账期" v-if="form.id" required>
          <el-radio-group v-model="form.settle_period">
            <el-radio
              :label="item.value"
              v-for="(item, i) in accountPeriod"
              :key="i"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { ObjectChangedValue } from "@/js/utils";
import { coopType,accountPeriod } from "./dict";
export default {
  data() {
    return {
      coopType,
      accountPeriod,
      form: {},
      temp: {},
      change_categories: [],
      addServiceDialog: false,
      categories: "",
      coach_id: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.coach_id = this.$route.query.id;
    this.getCategories();
  },
  computed: {
    venueArea() {
      return this.$store.state.venueArea;
    },
  },
  methods: {
    getCategories() {
      this.$get("user/mechanismCategory/queryListPageChild", {
        status: 2,
        type: 2,
        source: "课程",
      }).then((res) => {
        this.categories = res.data.data;
      });
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    check() {
      if(!this.form.mechanism_id){
          this.$message('请选择机构')
          return false
      }
      if(!this.form.end_time){
          this.$message('请选择截至日期')
          return false
      }
      if(this.form.type == 3 && this.change_categories.length == 0){
          this.$message('请选择类目')
          return false
      }
      if(this.form.type == 3){
          this.form.category = this.change_categories.join(',')
      }

      return true
    },
    updateForm() {
      if(this.form.type == 3 && this.change_categories.length == 0){
          this.$message('请选择类目')
          return false
      }
      if(this.form.type == 3){
          this.form.category = this.change_categories.join(',')
      }
      this.updateServie();
    },
    submitForm() {
      if (this.check()) {
        this.addNew();
      }
    },

    addNew() {
      let url = "/user/coachUnionPartnership/insert";
      let data = {
        handler_admin_id: this.adminInfo.id,
        handler_admin: this.adminInfo.name,
        coach_id: this.coach_id,
        ...this.form,
      };

      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      data.coach_id = this.coach_id
      let url = "/user/coachUnionPartnership/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>